import { useContext } from 'react';
/**
 * Хук для использования именованного контекста компонента.
 */
export function useComponentContext(ComponentContext, componentName, childName) {
    const context = useContext(ComponentContext);
    if (!context) {
        throw new Error(`${childName} component cannot be rendered outside the ${componentName} component`);
    }
    return context;
}
